import { type PlayerProfileResponse } from '@on3/api';
import { MobileMPU } from 'components/Ads/MobileMPU';
import { PhotosThumbnailList } from 'components/Db/Profile/PhotosThumbnailList/PhotosThumbnailList';
import { PlayerContact } from 'components/Db/Profile/PlayerContact';
import { ProfileValuationModule } from 'components/Db/Profile/ProfileValuationModule';
import { SecondaryRankings } from 'components/Db/Profile/SecondaryRankings';
import { DatabaseLayout } from 'components/Layouts/DatabaseLayout';
import { PlayerNilDeals } from 'components/Nil/DealTracker/PlayerNilDeals';
import { AdminLink } from 'components/User/AdminLink';
import useAthlete from 'contexts/AthleteProvider';
import { type PlayerProfilePageProps } from 'pages/rivals/[id]';

import { PlayerBio } from './PlayerBio';
import { PlayerHeader } from './PlayerHeader';
import { PlayerInterestsModule } from './PlayerInterests/PlayerInterestsModule';
import { PlayerNewsModule } from './PlayerNews/PlayerNewsModule';
import { PlayerSearch } from './PlayerSearch';
import styles from './SecondaryPlayerProfile.module.scss';

export const SecondaryPlayerProfile = ({
  college,
  photos,
  news,
  nilValuation,
  nilGrowth,
  nilDeals,
  rankingsPlayer,
  recruit,
  topTeams,
}: PlayerProfilePageProps) => {
  const { athlete, contactInfo } = useAthlete();

  const showPhotos = !!photos?.list?.length;
  const showRankings = !!rankingsPlayer;
  const showNilDeals = !!nilDeals?.list?.length;
  const showTopTeams = !!topTeams?.list?.length;

  return (
    <DatabaseLayout>
      <div className={styles.block}>
        <AdminLink path={`/people/${athlete?.slug}/edit/`} />
        <section className={styles.playerDetail}>
          <header>
            <h1>{athlete?.name}</h1>
            <PlayerSearch />
          </header>
          <PlayerHeader player={athlete as PlayerProfileResponse} />
        </section>

        <section className={styles.valuations}>
          <ProfileValuationModule
            latestValuation={nilValuation}
            valuationGrowth={nilGrowth}
          />
        </section>

        <div className={styles.modules}>
          {showRankings && (
            <section>
              <SecondaryRankings
                collegeData={college}
                playerRankings={rankingsPlayer}
                recruitData={recruit}
              />
            </section>
          )}

          {athlete?.description && (
            <PlayerBio description={athlete?.description} />
          )}

          {showNilDeals && <PlayerNilDeals playerDeals={nilDeals} />}

          {showTopTeams && (
            <PlayerInterestsModule
              list={topTeams.list?.slice(0, 5) || []}
              recruitmentKey={athlete?.recruitmentKey}
            />
          )}

          <MobileMPU id="mobile_mpu_middle" incontent />

          <div className={styles.bottom}>
            <div>
              {!!news?.list?.length && (
                <PlayerNewsModule
                  recruitmentKey={athlete?.recruitmentKey || 0}
                  recruitsArticles={news}
                />
              )}

              {showPhotos && (
                <section className={styles.photos}>
                  <h2>Photos</h2>
                  <PhotosThumbnailList playerImages={photos} />
                </section>
              )}
            </div>
            <div>
              {contactInfo && (
                <PlayerContact
                  contactInfo={contactInfo}
                  player={athlete as PlayerProfileResponse}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </DatabaseLayout>
  );
};
